'use client';

import type {As} from '@chakra-ui/react';
import type {ComponentWithAs, PropsOf} from '@chakra-ui/system';
import {forwardRef} from '@chakra-ui/system';
import {ChakraUl} from '@linx-security/ui/utils/chakra-elements';
import {dataAttr} from '@utils';

import {ListItem} from './ListItem';
import {useStyles} from './context';
import {parts} from './theme/anatomy';

type Props = PropsOf<typeof ChakraUl> & {
  isLoaded?: boolean;
  noOfSkeletonItems?: number;
  isVertical?: boolean;
};

export const List: ComponentWithAs<As, Props> = forwardRef(
  ({isLoaded = true, noOfSkeletonItems = 5, listStyleType, isVertical, ...props}, ref) => {
    const {container} = useStyles();
    if (!isLoaded) {
      return (
        <ChakraUl
          __css={container}
          ref={ref}
          {...parts.container.attrs}
          {...props}
          data-vertical={dataAttr(isVertical)}
        >
          {new Array(noOfSkeletonItems).fill(null).map((_, i) => (
            <ListItem isListVertical={isVertical} listStyleType={listStyleType} icon={null} isLoaded={false} key={i} />
          ))}
        </ChakraUl>
      );
    }

    return (
      <ChakraUl
        __css={container}
        ref={ref}
        {...parts.container.attrs}
        data-vertical={dataAttr(isVertical)}
        {...props}
      />
    );
  },
);

export type {Props as ListProps};
